import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
  standalone: false,
})
export class ConfirmationComponent implements OnInit {
  matDialogRef = inject<MatDialogRef<ConfirmationComponent>>(MatDialogRef);
  private data = inject(MAT_DIALOG_DATA);

  title: string;
  message: string;
  btnOkText: string;
  btnCancelText: string;

  constructor() {
    this.title = this.data.title;
    this.message = this.data.message;
    this.btnOkText = this.data.btnOkText || 'Si';
    this.btnCancelText = this.data.btnCancelText || 'No';
  }

  ngOnInit() {}
}
